// extracted by mini-css-extract-plugin
module.exports = {"Routes":"Layout_Routes__3A3k8"};